import { Navigate, useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const user_access_token = Cookies.get('user_access_token');
  const location = useLocation();

  if (!user_access_token) {
    const redirectTo = location.pathname + location.search;
    const loginUrl = redirectTo !== '/' ? `/auth/login?redirect=${encodeURIComponent(redirectTo)}` : '/auth/login';
    return <Navigate to={loginUrl} replace />;
  }

  return children;
};

export default ProtectedRoute;
